export enum USER_LOGIN_TYPES {
  SAVE_USER_LOGIN = 'SAVE_USER_LOGIN',
  SAVE_EMPRESA_LOGO = 'SAVE_EMPRESA_LOGO',
  UPDATE_DATA_USER = 'UPDATE_DATA_USER',
  CHANGE_DIMENSIONS = 'CHANGE_DIMENSIONS',
  SAVE_LIMITE = 'SAVE_LIMITE',
  SAVE_SESSION_DATA = 'SAVE_SESSION_DATA',
  UPDATE_DATA_CONFIG = 'UPDATE_DATA_CONFIG',
}
